import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getApplicationByNumber, getOperations } from 'api';
import { listPreDaNotifications } from 'pages/PageDefectAct/api';
import { DefectAct } from 'pages/PageDefectAct/interfaces';
import { DefectActProvider } from 'pages/PageDefectAct/providers';
import { getPath as getDefectActPath } from 'pages/PageDefectAct';

export const path = '/application/:applicationNumber/defect-act/new';
export const getPath = (applicationNumber: string): string => `/application/${applicationNumber}/defect-act/new`;

const PageDefectActNew: React.FC = (props) => {
  const { applicationNumber } = useParams<{ applicationNumber: string }>();

  const DefectActNew = Loadable.Map({
    loader: {
      page: () => import('./page'),
      application: () => getApplicationByNumber(applicationNumber),
      operations: () => getOperations({ applicationNumber }),
      // pre-уведомления могут быть созданы до самого ДА; если их нет — пустой список
      preNotifications: () =>
        listPreDaNotifications(applicationNumber).catch(() => ({
          notifications: [],
          overallStatusId: 0,
          overallStatusName: '',
        })),
    },
    loading: LoadableLoading,
    render({ application, operations, preNotifications, page }, loadedProps: {}) {
      // Если ДА уже создан — отправляем на страницу просмотра
      if (application.applications[0].defectActExist) {
        return <Redirect to={getDefectActPath(applicationNumber)} />;
      }

      const Page = page.default;

      // ДА ещё не создан — собираем минимальный объект для DefectActProvider
      const defectAct: DefectAct.IDefectAct = {
        applicationNumber,
        photoList: [],
        type: '',
        preNotifications: preNotifications.notifications,
      };

      return (
        <DefectActProvider application={application} defectAct={defectAct} operations={operations}>
          <Page {...loadedProps} />
        </DefectActProvider>
      );
    },
  });

  return <DefectActNew {...props} />;
};

export default PageDefectActNew;
